import { TDepositAmountWidgetResult } from '../types';

export const mapResponse400 = (): TDepositAmountWidgetResult => {
  return '';
};
